import * as React from 'react';
import axios from 'axios';
import LogPlusAnyResourcesAutocomplete from './LogPlusAnyResourcesAutocomplete';
import { IItSystemListItem } from './IModels';
import { Typography } from '@material-ui/core';

interface GetItSystemsAutocompleteResult {
	success: boolean,
	status?: "LogDisabled",
	items?: IItSystemListItem[]
}

export interface IAutocompleteParams {
	maxRows: number,
	filterId?: string,
}

interface IProps<T> {
	value: T[],
	onSelect: (value: T[]) => void,
	multiple?: true | false,
	placeholderText?: string,
	error: boolean;
	helperText: string,
	searchIn: (keyof T)[],
	filterId: string,
}

export default function LogPlusItSystemsAutocomplete(props: IProps<IItSystemListItem>)
{
	const getOptionSelected = (option: IItSystemListItem, value: IItSystemListItem) => {
		return option.Id === value.Id;
	}

	return (<LogPlusAnyResourcesAutocomplete
		{...props}
		getOptionLabel={(option: IItSystemListItem) => option.Name}
		getOptionSelected={getOptionSelected}
		createRequest={(text: string) => {
			return {
				text: text,
			}
		}}
		loadOptions={(request, callback) => {

			axios.get<GetItSystemsAutocompleteResult>('/LogPlusResources/GetItSystemsAutocomplete/', {
				params: {
					search: request.text,
					searchIn: props.searchIn?.join(','),
					max: 20,
					filterId: props.filterId,
				}
			})
				.then(r => {
					callback(r.data.items);
				});
		}}
		renderOption={(option) => {
			return (<div>
				{option.Name}
				<Typography variant="body2" color="textSecondary">
					{option.Description}
				</Typography>
			</div>);
		}}
	/>)
}